import { UIComponentHandler } from '../../../../toolkit/uicomponent';
import * as React from 'react';
import { ToneDto } from '../../../../../core/dto/tonedto';
import { BaseContext } from '../../../../../utils/basecontext';
import { CRBTUIViewImpl } from '../../crbt/crbtuiview';
import { Strings } from '../../../../../utils/resources/strings';
import { SearchListToneViewModelImpl } from '../searchlistviewmodel';
import { SearchListComponentProps } from '../searchlistcomponent';
import { GridComponent } from '../../../../toolkit/grid/gridcomponent';
import { ArtistSearchListCSSStyle } from './artistlistcss';
import { ArtistSearchListComponentProps, ArtistSearchListComponentHandler } from './artistlistcomponent';
import { NoResultComponent } from '../../../nametunes/noresult/noresultcomponent';
import { LoaderComponent } from '../../../../toolkit/loader/loadercomponent';
import { LoaderWrapperComponent } from '../../../popup/loaderwrappercomponent';
import {ArtistSearchListComponenState} from './artistlistcomponent';
import { GridPaginationComponent } from '../../../../toolkit/grid/gridpagination/gridpaginationcomponent';
import './artistlist-style.css';

export class ArtistSearchListViewImpl extends CRBTUIViewImpl
{
    private featuredCategoryListViewModel: SearchListToneViewModelImpl;
    private loaderWrapperComponent:LoaderWrapperComponent;
    private paginationComponent: GridPaginationComponent<ToneDto>;

    constructor(offset: string, context: BaseContext, handler: UIComponentHandler)
    {
        super(context, handler);
        
        this.featuredCategoryListViewModel = new SearchListToneViewModelImpl(
            offset,context, "40px", 
            context.getResources().getString(Strings.search_results_for));
            
            this.featuredCategoryListViewModel.setListDatas([]);        
    }

    bindHandlers()
    {
         this.onLoadMore = this.onLoadMore.bind(this); 
        this.showLoader = this.showLoader.bind(this);
        this.dismissLoader = this.dismissLoader.bind(this);
    }

    getChildComponent(props: ArtistSearchListComponentProps, state: ArtistSearchListComponenState, cssStyle: ArtistSearchListCSSStyle): JSX.Element
    {
        
        return (
            <>
            <h2 id="artist-list-title" style={(this.getUICSSStyle() as ArtistSearchListCSSStyle).getTitleCSSStyle()}>{props.context.getResources().getString(Strings.search_results_for) + (this.getUIProps() as SearchListComponentProps).searchKey}</h2>
            {
                this.featuredCategoryListViewModel.getListOfDatas().length > 0 &&
                 <>
                    <GridComponent listViewModel={this.featuredCategoryListViewModel} context={props.context}/>
                    <div id="artist-list-pagination" style={cssStyle.getPaginationCSSStyle()}>
                            <GridPaginationComponent ref={(item: any) => this.paginationComponent = item} onPageSelected={this.onLoadMore} listViewModel={this.featuredCategoryListViewModel} context={props.context}/>
                        </div>
                </>} 
            {
                state.isDataNotLoaded &&
                <div id="artist-list-no_result" style={{width:'100%',height:'100%'}}>
                    <NoResultComponent   context={this.getContext()}/>
                </div>    
            }
            <LoaderWrapperComponent ref={(item: any) => this.loaderWrapperComponent = item} context={props.context}/>
              
            </>
        );
    }

    getNavigationPath()
    {
        return [this.getUIProps().context.getResources().getString(Strings.home), 
            this.getUIProps().context.getResources().getString(Strings.search), 
            this.getUIProps().context.getResources().getString(Strings.artist), 
            (this.getUIProps() as ArtistSearchListComponentProps).searchKey];
    }

    getArtistSearchImg()
    {
        return "banner.jpg";
    }

    onLoadMore(startIndex: number, offset: number)
    {
        (this.getUIComponentHandler() as ArtistSearchListComponentHandler).loadMoreTones(startIndex, offset);
    }

    updatePagination(isOnLoadMore: boolean)
    {
        if(!isOnLoadMore)
        {
            this.featuredCategoryListViewModel.resetPaginationState();
        }
        else
        {
            this.paginationComponent !== undefined && this.paginationComponent.updatePaginationCount();
        }
    }
    showLoader()
    {
       
        this.loaderWrapperComponent !== null && this.loaderWrapperComponent.setShowWindow(true,  <LoaderComponent context={this.getUIProps().context}/>);   
    }
  
    dismissLoader()
    { 
        this.loaderWrapperComponent !== null && this.loaderWrapperComponent.setShowWindow(false, <></>);
    }
    getListOfDatas(): ToneDto[] {
        return this.featuredCategoryListViewModel.getListOfDatas();
    }

    setListOfDatas(listofTones: ToneDto[])
    {
        this.featuredCategoryListViewModel.setListDatas(listofTones);
    }
 
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/searchlist/artist/artistlistview.tsx